module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Roman.75504a4b.ttf";